<template>
  <div class="wrapper">
    <aside class="base-sidebar" :class="{ 'togled-left-bar': showFullSideMenu }">
      <div class="sidebar-sticky">
        <ul class="nav flex-column">
          <li
            v-for="link of links"
            :key="link.text"
            :class="['nav-item', link.divider ? 'divider' : '', link.subactive ? 'subactive' : '']"
          >
            <router-link
              v-if="!link.divider"
              :to="link.url"
              :class="{ active: link.active || (link.sublinks && link.sublinks.find((el) => el.active)) }"
              class="nav-menu-item align-middle"
            >
              <div class="row">
                <div class="col-sm-2">
                  <font-awesome-icon class="sidebar-icon" :icon="link.icon" />
                </div>
                <div class="col link-text">{{ link.text }}</div>
              </div>
              <div v-if="link.sublinks && link.subactive" class="sublinks-wrapper" style="margin-top: 0.3rem">
                <li
                  v-for="sublink of link.sublinks"
                  :key="sublink.text"
                  :class="['nav-item', link.divider ? 'divider' : '']"
                >
                  <router-link
                    v-if="!sublink.divider"
                    :to="sublink.url"
                    :class="{ active: sublink.active }"
                    class="nav-sublink align-middle"
                  >
                    <div class="row">
                      <div class="col-sm-2"></div>
                      <div class="col sublink-text">{{ sublink.text }}</div>
                    </div>
                    <span v-if="sublink.active" class="sr-only">(current)</span>
                  </router-link>
                </li>
              </div>
              <span v-if="link.active" class="sr-only">(current)</span>
            </router-link>
          </li>
          <li class="nav-subitem bottom-sidebar-item">
            <div
              class="togle-button-wrapper nav-menu-item align-middle pointer noselect"
              @click="showFullSideMenu = !showFullSideMenu"
            >
              <div class="row">
                <div class="col-sm-2">
                  <font-awesome-icon v-if="showFullSideMenu" class="sidebar-icon" icon="angle-double-left" />
                  <font-awesome-icon v-else class="sidebar-icon" icon="angle-double-right" />
                </div>
                <div class="col link-text">Свернуть</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </aside>
    <MobileSideBar v-if="showSideMenu" @close-menu="showSideMenu = false" />
    <main class="content">
      <Logout v-if="showLogout" @hide-logout="showLogout = false" class="logout-card" ref="logoutPopup" />
      <!--Events v-if="showEvents" class="content col-md-9 ml-sm-auto col-lg-10 px-4 events" /-->
      <slot />
    </main>
    <header class="navbar-expand-lg navbar-light bg-light top-bar">
      <button
        class="hamburger hamburger--arrow"
        type="button"
        :class="{ 'is-active': showSideMenu }"
        @click="showSideMenu = !showSideMenu"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
      <div class="bell-item noselect pointer" @click="showEvents = !showEvents" style="visibility: hidden">
        <div class="numberCircle">3</div>
        <font-awesome-icon class="notifications-bell-icon" icon="bell" :style="{ color: '#404040' }" />
      </div>
      <div
        class="user-item justify-content-center noselect pointer"
        @click="showLogout = !showLogout"
        v-click-outside="hideLogout"
      >
        <font-awesome-icon class="user-icon" icon="user-circle" :style="{ color: '#404040' }" />
      </div>
    </header>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { mapActions } from 'vuex'

export default {
  name: 'BaseWorkspaceLayout',
  computed: {
    links () {
      const links = [
        {
          text: 'Наблюдение',
          url: '/watch',
          icon: 'eye',
          subactiveRoutes: ['/devices'],
          sublinks: [
            {
              text: 'Карта',
              url: '/watch'
            }, {
              text: 'Устройства',
              url: '/devices'
            }
          ]
        }, {
          text: 'Аренда',
          url: '/rent',
          icon: 'retweet'
        }, {
          text: 'Тех. обслуживание',
          url: '/serve',
          subactiveRoutes: ['/service-works'],
          sublinks: [
            {
              text: 'Список',
              url: '/serve'
            }, {
              text: 'Работы',
              url: '/service-works'
            }
          ],
          icon: 'wrench'
        }, {
          text: 'divider1',
          divider: true
        }, {
          text: 'Автомобили',
          url: '/cars',
          icon: 'car'
        }, {
          text: 'Водители',
          url: '/drivers',
          icon: ['fas', 'id-badge']
        }, {
          text: 'Организации',
          url: '/companies',
          icon: 'briefcase'
        }, {
          text: 'divider2',
          divider: true
        }, {
          text: 'Шаблоны',
          url: '/templates',
          icon: 'file-alt'
        }, {
          text: 'Пользователи',
          url: '/users',
          icon: 'user-lock'
        }
      ]
      for (const link of links) {
        if (link.subactiveRoutes &&
          link.subactiveRoutes.find(x => this.$route.path.includes(x))) {
          link.subactive = true
        }

        if (this.$route.path.includes(link.url)) {
          link.subactive = true
        }

        if (link.url === this.$route.path) {
          link.active = true
        }

        if (!link.sublinks) {
          continue
        }

        link.sublinks.forEach(el => {
          if (el.url === this.$route.path) {
            el.active = true
            link.active = true
          } else {
            el.active = false
          }
        })
      }
      return links
    }
  },
  mounted () {
    this.loadAuthedUser()
  },
  methods: {
    hideLogout (e) {
      if (this.$refs.logoutPopup && !e.path.includes(this.$refs.logoutPopup.$el)) {
        this.showLogout = false
      }
    },
    hideEvents (e) {
      if (this.$refs.eventsPopup && !e.path.includes(this.$refs.eventsPopup.$el)) {
        this.showEvents = false
      }
    },
    ...mapActions('taxi/users', [
      'loadAuthedUser'
    ])
  },
  watch: {
    $route (to, from) {
      this.showFullSideMenu = false
    }
  },
  data () {
    return {
      showEvents: false,
      showLogout: false,
      showSideMenu: false,
      showFullSideMenu: false
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss" scoped>
  // HAMBURGER STYLING
  $hamburger-layer-width: 20px;
  $hamburger-layer-height: 2px;
  $hamburger-layer-spacing: 3px;
  $hamburger-padding-x: 0;
  $hamburger-padding-y: 0;
  $hamburger-layer-color: #55606a;
  @import "hamburgers/_sass/hamburgers/hamburgers.scss";
</style>

<style lang="scss" scoped>
  @import "@/assets/scss/globals.scss";
  @import "bootstrap";

  .wrapper {
    display: grid;
    grid-template-columns: 230px auto;
    grid-template-rows: $bwlayuotHeader minmax(calc(100vh - #{$bwlayuotHeader}), max-content);
  }

  @media screen and (max-width: 1199px) {
    .wrapper {
      grid-template-columns: 0 auto;
    }
    .link-text {
      display: block;
    }
    .base-sidebar {
      display: none;
    }
    .hamburger {
      visibility: visible !important;
    }
  }
  @media screen and (max-width: 576px) {
    .wrapper {
      font-size: 0.8rem;
    }
  }

  header {
    width: 100%;
    height: 43px;
    align-items: center;
    padding: 0;
    display: flex;
    z-index: 99999;
  }
  .base-sidebar {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
  }
  .base-sidebar .sidebar-sticky {
    position: sticky;
    top: calc(#{$bwlayuotHeader} + 15px);
    height: calc(100vh - #{$bwlayuotHeader} - 15px);
  }
  .hamburger {
    padding: 0;
    margin-left: 14px;
    visibility: hidden;
  }
  main {
    grid-column: 2 / 4;
    grid-row: 2 / 3;
  }
  button {
    outline: none;
  }
  .logout-card {
    z-index: 9999;
    margin-right: calc(100% - 100vw + 0.2rem);
  }
  .events {
    z-index: 9999;
  }
  .base-sidebar {
    padding: 15px 0 0;
    font-size: 0.875rem;
    font-weight: 400;
    background-color: #fafafa;
    border-right: 1px solid #ddd;
    li {
      width: 100%;
    }
    .nav-menu-item {
      @extend .nav-link;
      color: #707070;
      &:hover {
        color: #4f4f4f;
      }
      &.active .sidebar-icon {
        color: #0597f2;
      }
      &.active .link-text {
        font-weight: 600;
        color: #0597f2;
      }
    }
    .nav-sublink {
      @extend .nav-link;
      color: #707070;
      &:hover {
        color: #4f4f4f;
      }
      &.active .sublink-icon {
        color: #0597f2;
      }
      &.active .sublink-text {
        font-weight: 600;
        color: #0597f2;
      }
    }
  }
  .divider {
    margin: 0.25rem 0 0.25rem 0;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
  }
  .bell-item {
    position: relative;
    width: 25px;
    height: 25px;
    vertical-align: middle !important;
    margin-left: auto;
  }
  .notifications-bell-icon {
    height: 25px !important;
    width: 25px !important;
    position: absolute;
  }
  .top-bar {
    height: #{$bwlayuotHeader};
    position: fixed;
    border-bottom: 1px solid #ddd;
  }
  .numberCircle {
    position: absolute;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    padding: 0px;
    background: #fff;
    border: 2px solid #f2b950;
    background-color: #f2b950;
    text-align: center;
    color: white;
    z-index: 9999;
    font-size: 12px;
    left: 12px;
    bottom: 9px;
  }
  .user-icon {
    height: 25px !important;
    width: 25px !important;
    vertical-align: middle !important;
  }
  .user-item {
    height: 29px;
    margin-left: 1.2rem;
    margin-right: calc(100% - 100vw + 39px);
  }
  .settings-item {
    margin-left: 10px;
  }
  .settings-icon {
    height: 25px !important;
    width: 25px !important;
  }
  .sidebar-icon {
    width: 18px;
    height: 18px;
    margin-right: 30px;
    vertical-align: -3px;
  }
  .btn-primary {
    background-color: #0597f2 !important;
  }
  .btn-link {
    color: #0597f2 !important;
  }
  .content {
    font-weight: 400;
    width: 100%;
    height: 100%;
  }
  .noselect {
    user-select: none;
  }
  .pointer {
    cursor: pointer;
  }
  .togled-left-bar {
    width: 220px;
    z-index: 9999;
    .link-text {
      display: block;
    }
  }
  .bottom-sidebar-item {
    position: absolute;
    bottom: 0.3rem;
    display: none;
  }
</style>
